import { createSelector } from 'reselect';
import sumServicesReport from './sumReport';
import { extractFilterIds, filterByBarber, getBarberReports } from '../selectors';

export const getAllBarbersFilter = state => state.reports.saleReport.barberFilter;
export const getActiveBarbersFilterIds = createSelector(
  getAllBarbersFilter,
  extractFilterIds
);

export const getServiceSalesReport = createSelector(
  getActiveBarbersFilterIds,
  getBarberReports,
  filterByBarber
);

export const getServiceSalesSum = createSelector(
  getServiceSalesReport,
  sumServicesReport
);
